import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetTrainersBySearch(club, url) {

  var url = "/reservation/get_trainers_by_search/" + club + url; 

  return FetchGetDataWithAuthNEW(url);
}

